@if (show.stepper) {
  <div>
    <mat-horizontal-stepper
      labelPosition="bottom"
      [linear]="isLinear"
      aria-label="Transcript order progress"
      #stepper>
      <mat-step [completed]="content.step1StatusComplete">
        <ng-template matStepLabel>
          <span class="nsc-step-label">Enter Personal Information</span>
        </ng-template>
      </mat-step>
      <mat-step [completed]="content.step2StatusComplete">
        <ng-template matStepLabel>
          <span class="nsc-step-label">Select Transcript and Delivery Details</span>
        </ng-template>
      </mat-step>
      <mat-step [completed]="content.step3StatusComplete">
        <ng-template matStepLabel>
          <span class="nsc-step-label">Confirm Order and Checkout</span>
        </ng-template>
      </mat-step>
    </mat-horizontal-stepper>
    <!--
      WCAG 2.2 AA — 4.1.3 Status Messages.
      Visually-hidden live region announces step transitions
      ("Step 2 of 3: Select Transcript and Delivery Details") to
      screen-reader users. `role="status"` already implies
      `aria-live="polite"` and `aria-atomic="true"`, so those attributes are
      intentionally omitted (matches the cleanup applied in commit 44a66a1 to
      form-field-files).
    -->
    <div class="cdk-visually-hidden" role="status">
      {{ currentStepAnnouncement }}
    </div>
  </div>
}
